  /* ==============================
     FAQ ACCORDION (SAFE)
     ============================== */
  const faqButtons = document.querySelectorAll(".faq-question");

  if (faqButtons.length) {
    faqButtons.forEach(btn => {
      btn.addEventListener("click", () => {
        const answer = btn.nextElementSibling;
        if (!answer) return;

        const isOpen = answer.classList.contains("open");

        answer.classList.toggle("open");
        btn.setAttribute("aria-expanded", String(!isOpen));
      });
    });
  }

  /* ==============================
   EXPANDABLE FEATURE DETAILS
   ============================== */

const featureDetailButtons =
  document.querySelectorAll(
    ".feature-details-toggle"
  );


if (featureDetailButtons.length) {

  featureDetailButtons.forEach(
    function (button) {

      button.addEventListener(
        "click",
        function () {

          const card =
            button.closest(
              ".feature-card"
            );


          if (!card) {
            return;
          }


          const details =
            card.querySelector(
              ".feature-details"
            );


          if (!details) {
            return;
          }


          const isOpen =
            details.classList.contains(
              "open"
            );


          /*
            Toggle expanded content.
          */

          details.classList.toggle(
            "open"
          );


          /*
            Keep accessibility state in sync.
          */

          button.setAttribute(
            "aria-expanded",
            String(!isOpen)
          );


          /*
            Update the button wording.
          */

          button.childNodes[0].nodeValue =
            isOpen
              ? "View how the safety lock works "
              : "Hide details ";

        }
      );

    }
  );

}



/* ==========================================
   STICKY ARTICLE QUICK NAVIGATION

   Keeps the navigation aligned with the
   article content when scrolling.

   Preserves:
   - Existing sticky behaviour
   - Anchor spacer functionality
   - Search dropdown stacking order
   - Product card hover behaviour

   Updated on 21/10/2026
========================================== */

document.addEventListener("DOMContentLoaded", function () {

  const nav = document.querySelector(".anchor-links");
  const spacer = document.querySelector(".anchor-spacer");

  if (!nav || !spacer) return;

  /*
   * Store the navigation's original position.
   * The spacer remains in the document flow
   * when the navigation becomes fixed.
   */
  const trigger = nav.getBoundingClientRect().top + window.scrollY;


  /*
   * Update the navigation's horizontal position
   * and width to match its original content area.
   */
  function updateNavigationPosition() {

    if (!nav.classList.contains("sticky")) return;

    const rect = spacer.getBoundingClientRect();

    nav.style.left = rect.left + "px";
    nav.style.width = rect.width + "px";
    nav.style.right = "auto";

  }


  /*
   * Activate or deactivate sticky navigation
   * depending on the current scroll position.
   */
  function updateStickyNavigation() {

    if (window.scrollY > trigger) {

      nav.classList.add("sticky");

      spacer.style.height = nav.offsetHeight + "px";

      updateNavigationPosition();

    } else {

      nav.classList.remove("sticky");

      spacer.style.height = "0px";

      /* Restore original positioning */
      nav.style.left = "";
      nav.style.width = "";
      nav.style.right = "";

    }

  }


  /*
   * Update navigation when scrolling
   * or resizing the browser window.
   */
  window.addEventListener("scroll", updateStickyNavigation);

  window.addEventListener("resize", function () {

    updateStickyNavigation();

  });


  /* Check initial state on page load */
  updateStickyNavigation();

});



document.addEventListener("DOMContentLoaded", function () {

    const links = document.querySelectorAll(".anchor-links a");
    const sections = [...links].map(link =>
        document.querySelector(link.getAttribute("href"))
    );

    function setActiveLink() {

        let currentIndex = -1;

        sections.forEach((section, i) => {
            if (!section) return;

            const rect = section.getBoundingClientRect();

            if (rect.top <= 120) {
                currentIndex = i;
            }
        });

        links.forEach(link => link.classList.remove("active"));

        if (currentIndex >= 0) {
            links[currentIndex].classList.add("active");
        }
    }

    window.addEventListener("scroll", setActiveLink);
    setActiveLink();

});
